export default __webpack_public_path__ + "static/03-03-math-equation-balancing-4d285f3be2bd1df03f523a85fe124e55.mp4";